import * as S from './GuestRating.styles';

const GuestRating = ({availableOTAs, source, hotelRating, reviewCount, ratingCount}) => {
  const isGIRating = source === 'GI';
  const isExpDataExists = availableOTAs?.includes('EXP');

  return (
    <>
      <S.GoRatingBlock hotelRating={hotelRating}>
        {isGIRating && <S.GoRatingTextWrapper>goRating</S.GoRatingTextWrapper>}
        <S.AvgReviewTextWrapperDiv>
          <S.AvgReviewTextWrapper>{hotelRating}</S.AvgReviewTextWrapper>
          <S.TotalReviewTextWrapper>/5</S.TotalReviewTextWrapper>
        </S.AvgReviewTextWrapperDiv>
        <S.ReviewCountTextWrapper data-testid="d-GuestReview-ratingCount">
          {ratingCount} Ratings
        </S.ReviewCountTextWrapper>
        <S.RatingsCountTextWrapper data-testid="d-GuestReview-reviewCount">
          {!isExpDataExists ? `${reviewCount} Reviews` : null}
        </S.RatingsCountTextWrapper>
      </S.GoRatingBlock>
    </>
  );
};

export default GuestRating;
